export interface PositionButtonsProps{
    onClick:Function
}
export function PositionButtons(props:PositionButtonsProps){
        let firstRowButtons:JSX.Element[] = []
        for(let i = 0; i < 7; i++){
          let b:JSX.Element = <PositionButton index={i} onClick={props.onClick} key={i}/>
          firstRowButtons.push(b)
        }
        return  <div>
                  <div className='first-row'>{firstRowButtons}</div>
                </div>
}
export interface PositionButtonProps{
  index:number
  onClick:Function
}
export function PositionButton(props:PositionButtonProps){
  const onClick = (e:React.MouseEvent) => {
    e.stopPropagation()
    props.onClick(props.index)
}
  return  <button className="note-button" onClick={onClick} type="button">
            {String(props.index + 1)}
          </button>
}